/**
 * Row data: the settings registry (1.0b deliverable 14). One row per `setting.key`: its schema,
 * its default (the value read when the key was never stored), its owner and its gate. Later-phase
 * keys arrive with the contracts round of their phase: amendments 2.2 section 7's Foundry world id
 * with CS r6a; its out-of-character names and ingest gaps, and baseline section 3's transcript
 * consent, later. No
 * ceiling, budget or backup key exists (PLAN section 2). Pure data (excluded from mutation
 * testing).
 */
import { SIZE_CAP_WORDS_DEFAULT } from '../domain/enums.js';
import { QuietWindow } from '../dto/quiet.js';
import { z } from '../zod.js';
import { CalloutMapV1 } from './callout-map.js';
import { FlagsSettingSchema } from './flags.js';
export const SETTING_SCHEMAS = {
    /** Stored flag values (P0-3); a missing key falls back to the flag's default. */
    flags: FlagsSettingSchema,
    /** The game-session dates that pause test runs (P0-2), so the Settings page may show them. */
    quiet_windows: z.array(QuietWindow),
    /** The size cap's nudge, in words (PLAN section 2, "Long documents": nothing is blocked). */
    size_cap_words: z.number().int().min(1000).max(1_000_000),
    /** Read time is read-aloud words divided by this (amendments 2.2 section 5). */
    readaloud_wpm: z.number().int().min(60).max(400),
    /** Typographic quotes and dashes as the GM types (amendments 2.2 section 5). */
    typography: z.boolean(),
    /** What pasted Notion callouts become (baseline section 4, "Notion paste"). */
    callout_map: CalloutMapV1,
    /**
     * The Foundry world the campaign plays in (amendments 2.2 §7; CS r6a deliverable 187): set by
     * 2.I's first applied import whose file names a world, shown and cleared in Settings, "Foundry"
     * (CS r6c). An import from another world is never a silent match.
     */
    foundry_world_id: z.string().min(1).max(64).nullable(),
};
export const SETTING_ROWS = [
    { key: 'flags', default: {}, owner: 'P0-3', since: 'design' },
    { key: 'quiet_windows', default: [], owner: 'P0-2', since: 'design' },
    { key: 'size_cap_words', default: SIZE_CAP_WORDS_DEFAULT, owner: '1.V-1', since: 'exit-1a' },
    { key: 'readaloud_wpm', default: 140, owner: '1.V-1', since: 'exit-1a' },
    { key: 'typography', default: true, owner: '1.V-1', since: 'exit-1a' },
    { key: 'callout_map', default: [], owner: '1.V-1', since: 'exit-1a' },
    { key: 'foundry_world_id', default: null, owner: '2.I', since: 'exit-2c' },
];
//# sourceMappingURL=rows-settings.js.map